module.exports = __webpack_public_path__ + "img/iys_nedir.a6de7f70.svg";